export default "__VITE_ASSET__DRf1u4FG__"